import {lightBulbSvg as Icon__small__lightBulbSvg} from '../Icon__small/Icon__small--lightBulb.js';

export var lightBulb = {
  name: 'lightBulb',
  category: 'icon',
  colorable: true,
  svg: Icon__small__lightBulbSvg,
};
